// Host-based brand detection so the same app can serve multiple live domains:
//   royalskincosmeticclinic.com         -> clinic  (client / public site)
//   admin.royalskincosmeticclinic.com   -> clinic  (backoffice)
//   docstateproperties.ae               -> docstate (client / public site)
//   admin.docstateproperties.ae         -> docstate (backoffice)
// On preview / localhost it returns {brand:null,type:null}, so routing stays
// path-based (/docstate for the portal, /admin for the backoffice).
export const hostInfo = () => {
  const h = (typeof window !== "undefined" && window.location.hostname) || "";
  const isAdmin = h.startsWith("admin.") || h.startsWith("app.");
  if (h.includes("docstateproperties")) return { brand: "docstate", type: isAdmin ? "admin" : "client" };
  if (h.includes("royalskincosmetic")) return { brand: "clinic", type: isAdmin ? "admin" : "client" };
  return { brand: null, type: null };
};

// Back-compat: brand only (used by favicon logic).
export const hostBrand = () => hostInfo().brand;

// The backoffice URL for a given brand (for cross-domain redirects from the
// client site's /admin to the dedicated backoffice subdomain).
export const adminHostFor = (brand) => {
  if (brand === "docstate") return "https://admin.docstateproperties.ae";
  if (brand === "clinic") return "https://admin.royalskincosmeticclinic.com";
  return "";
};

export const DOCSTATE_FAVICON = "/assets/docstate-mark.png";

export const setFavicon = (href) => {
  if (!href) return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
};

// Lightweight, fire-and-forget public page-view counter (per brand, per day).
export const trackVisit = (brand) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ brand }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
};
